var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIconGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2483",
    "data-name": "Group 2483",
    transform: "translate(-0.071 0.833)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_74",
    "data-name": "Ellipse 74",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(0.071 -0.833)",
    fill: "#8e9ea0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "user-solid",
    d: "M6.17,7.051A3.526,3.526,0,1,0,2.644,3.526,3.525,3.525,0,0,0,6.17,7.051ZM4.911,8.373A4.91,4.91,0,0,0,0,13.285a.818.818,0,0,0,.818.818h10.7a.818.818,0,0,0,.818-.818A4.91,4.91,0,0,0,7.429,8.373Z",
    transform: "translate(5.532 3.958)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconGray);
export default __webpack_public_path__ + "static/media/profile-icon-gray.f20b3c234e37ffd67962edf3940dc6aa.svg";
export { ForwardRef as ReactComponent };